module.exports = __webpack_public_path__ + "img/wav.e543f5e7.png";